export default __webpack_public_path__ + "static/media/s-testing.fe1b0e55.jpg";